const stubbedPaths = new Set<string>();
type StubSubscriber = (paths: string[]) => void;
const subscribers = new Set<StubSubscriber>();

function notifySubscribers() {
  const snapshot = Array.from(stubbedPaths);
  subscribers.forEach((subscriber) => subscriber(snapshot));
}

export function recordStubbedPath(path: string): void {
  if (!path) {
    return;
  }
  stubbedPaths.add(path);
  notifySubscribers();
}

export function getStubbedPaths(): string[] {
  return Array.from(stubbedPaths);
}

export function subscribeStubbedPaths(subscriber: StubSubscriber): () => void {
  subscribers.add(subscriber);
  subscriber(Array.from(stubbedPaths));
  return () => {
    subscribers.delete(subscriber);
  };
}
